var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row app"
  }, [_c('menu-aplicacoes'), _vm._v(" "), _c('div', {
    staticClass: "content-app"
  }, [_c('div', {
    staticClass: "topo"
  }), _vm._v(" "), _c('section', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e65fff7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = WEG8
// module chunks = 1